module.exports = __webpack_public_path__ + "img/searchEmpty_b.02381d33.svg";